export enum ModuleEnum {
  Home = 0,
  Registration = 1,
  Order = 2,
  Quotation = 3,
  Inventory = 4,
  Integration = 5,
  Report = 6,
  Claim = 7
}

